import React, { FC } from 'react';
import { LayoutChangeEvent, View } from 'react-native';
import TouchableElement from '@components/common/touchableElement';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';
import { getCardContainerStyle } from '@v2/pages/common/components/TraceabilityGraph/helpers/getCardContainerStyle';
import { TraceabilityGraphProps, TraceabilityNode } from '@v2/pages/common/components/TraceabilityGraph/types';
import { NodeCardContent } from './NodeCardContent';
import { NodePort } from './NodePort';

interface NodeCardProps extends Pick<TraceabilityGraphProps, 'C'> {
  node: TraceabilityNode;
  showLeftPort: boolean;
  showRightPort: boolean;
  normalizeNodeId: (value: string) => string;
  onLayout: (event: LayoutChangeEvent) => void;
}

export const TraceabilityNodeCard: FC<NodeCardProps> = ({ C, node, showLeftPort, showRightPort, normalizeNodeId, onLayout }) => {
  const testID = TEST_IDS.traceabilityGraph.node(normalizeNodeId(node.nodeId));
  const clickable = !!node.onPress && !node.disabled;

  return (
    <View onLayout={onLayout} style={{ width: '100%', position: 'relative' }}>
      {clickable ? (
        <TouchableElement testID={testID} onPress={node.onPress}>
          {({ boxStyle, pressHoverColor }) => (
            <View style={getCardContainerStyle({ C, node, boxStyle, pressHoverColor })}>
              <NodeCardContent C={C} node={node} />
            </View>
          )}
        </TouchableElement>
      ) : (
        <View testID={testID} style={getCardContainerStyle({ C, node })}>
          <NodeCardContent C={C} node={node} />
        </View>
      )}
      {showLeftPort && <NodePort C={C} side="left" />}
      {showRightPort && <NodePort C={C} side="right" />}
    </View>
  );
};
